"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* ++++++++++ --------------- SEPARATOR : DEFINITION --------------- ++++++++++ */

var _default = {
  name: 'Separator',
  props: {
    text: {
      type: 'string',
      default: 'or'
    },
    lineColor: {
      type: 'string',
      default: '#EEF2F6'
    },
    textMargin: {
      type: 'string',
      default: '15px'
    }
  }
};
exports.default = _default;